import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import "./styles/TableToolbar.css";

/**
 * TableToolbar - Top bar for tables with selection and actions
 * @param {Object} props
 * @param {number} props.selectedCount - Number of items selected
 * @param {string} props.checkboxState - 'checked', 'unchecked', or 'indeterminate'
 * @param {Function} props.onCheckboxChange - Handler for checkbox
 * @param {React.ReactNode} props.bulkActions - Bulk action dropdown/menu
 * @param {React.ReactNode} props.leftContent - Extra content beside the selection pill
 * @param {React.ReactNode} props.rightActions - Right side actions (refresh, sort, etc)
 */
const TableToolbar = ({
  selectedCount,
  checkboxState,
  onCheckboxChange,
  bulkActions,
  leftContent,
  rightActions,
}) => {
  const hasSelection = selectedCount > 0;

  return (
    <div className={`tableTopBar ${hasSelection ? "hasSelection" : ""}`}>
      <div className="tableTopBarLeft">
        <div className="tableTopSelection">
          <Checkbox
            size="small"
            checked={checkboxState === "checked"}
            indeterminate={checkboxState === "indeterminate"}
            onChange={onCheckboxChange}
            inputProps={{ "aria-label": "Select all rows" }}
          />
          <span>{hasSelection ? `${selectedCount} selected` : "Select all"}</span>
        </div>
        {hasSelection && bulkActions}
        {!hasSelection && leftContent}
      </div>
      <div className="tableTopBarRight">{rightActions}</div>
    </div>
  );
};

export default TableToolbar;
